import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';
import {observer} from './jobs';
import {PRODUCTION} from 'utils/env';

const initialState = undefined;

const store = createStore(
  reducers,
  initialState,
  compose(
    applyMiddleware(thunk),
    (!PRODUCTION && window.devToolsExtension) ? window.devToolsExtension() : f => f
  )
);

observer(store);

export default store;



// WEBPACK FOOTER //
// ./app/javascript/store/index.js